var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"transparent"},[_c('v-select',{staticClass:"ma-5",attrs:{"items":_vm.langs,"label":"Solo field","solo":""},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }